function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3886",
    width: 24,
    height: 24,
    rx: 4,
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50898",
    d: "m8.123 3.458 2.657 2.657-6.726 6.726L1.4 10.184zm4.677-.641-1.189-1.185a1.176 1.176 0 0 0-1.661 0L8.815 2.767l2.657 2.657L12.8 4.1a.906.906 0 0 0 0-1.283zM.008 13.919a.3.3 0 0 0 .366.36l2.961-.718L.679 10.9z",
    transform: "translate(5.071 4.634)",
    style: {
      fill: "#afafaf"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.4c4782178f81a59414f7e1425d953ede.svg";